(function () {
  'use strict';

  /* @ngdoc object
   * @name helpers.doctor
   * @description
   *
   */
  angular
    .module('helpers.doctor', [
      'ui.router'
    ]);
}());
